import script from "./AddClient.vue?vue&type=script&setup=true&lang=js"
export * from "./AddClient.vue?vue&type=script&setup=true&lang=js"

import "./AddClient.vue?vue&type=style&index=0&id=3569813c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3569813c"]])

export default __exports__